var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDnahla48 = function SvgAIconDnahla48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 2C17.2002 12.1538 32.5002 13.8462 32.5002 24C32.5002 34.1538 17.2002 35.8462 17.2002 46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7998 2C30.7998 5.09606 29.3773 7.40543 27.3998 9.40785M30.7998 46C30.7998 42.9039 29.3773 40.5946 27.3998 38.5921M20.5998 15.033C17.7908 17.4087 15.4998 20.0708 15.4998 24C15.4998 27.9292 17.7908 30.5913 20.5998 32.967",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24H32.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 18.9231H25.7002",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0498 3.69231H29.9498",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 7.5H19.75",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0498 44.3077H29.9498",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 40.5H28.25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 29.0769H30.8002",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3152 39.0634L43.6346 33.5098",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8231 40.2713L39.1272 32.302",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5185 37.5359L9.82892 30.7061",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3828 36.5005L5.96709 31.741",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10L7.77085 13.9241M7.77085 13.9241L11.695 12.6533M7.77085 13.9241L5.91354 17.5606",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4502 17.784L40.3332 16.7476M40.3332 16.7476L39.2969 18.8646M40.3332 16.7476L39.5768 14.5403",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgAIconDnahla48 as ReactComponent };
export default "data:image/svg+xml;base64,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";